import PropTypes from "prop-types";
import { cn } from "@helpers/general";
import { ComponentType } from "@constants/ComponentType";

function USPFakeImage({
  idx,
  tags = [],
  setRef,
  componentType,
  aspectRatio = "aspect-[0.8]",
  titleTextSize = "text-[0.12vw]",
  uspTextSize = "text-[0.12vw]",
  uspTextLineHeight = "leading-[160%]",
}) {
  return (
    <div
      className={cn(
        "w-full flex items-center bg-light-grey px-[9.98%]",
        aspectRatio,
        (componentType === ComponentType.PDP || componentType === ComponentType.PDP_ADS) &&
          "mobile:h-full"
      )}
      data-idx={idx}
      ref={setRef}
    >
      <div className="w-full">
        <p className={cn("font-bold font-sans mb-[0.5vw]", titleTextSize)}>Lifeproof Jewelry</p>
        <div className="text-left">
          <p className={cn("font-bold font-rigatoni", uspTextSize, uspTextLineHeight)}>
            Tarnish-Free
          </p>
          {(tags || []).includes("Components:Solid Gold") ? (
            <p className={cn("font-bold font-rigatoni", uspTextSize, uspTextLineHeight)}>
              Waterproof
            </p>
          ) : (
            <p className={cn("font-bold font-rigatoni", uspTextSize, uspTextLineHeight)}>
              Water-Resistant
            </p>
          )}
          <p className={cn("font-bold font-rigatoni", uspTextSize, uspTextLineHeight)}>
            Hypoallergenic
          </p>
        </div>
      </div>
    </div>
  );
}

USPFakeImage.propTypes = {
  idx: PropTypes.number.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  setRef: PropTypes.func,
  componentType: PropTypes.string.isRequired,
  aspectRatio: PropTypes.string,
  titleTextSize: PropTypes.string,
  uspTextSize: PropTypes.string,
  uspTextLineHeight: PropTypes.string,
};

export default USPFakeImage;
